import { render, staticRenderFns } from "./invite-patient.vue?vue&type=template&id=42292c96&scoped=true"
import script from "./invite-patient.vue?vue&type=script&lang=js"
export * from "./invite-patient.vue?vue&type=script&lang=js"
import style0 from "./invite-patient.vue?vue&type=style&index=0&id=42292c96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42292c96",
  null
  
)

export default component.exports